import { DateTime } from 'luxon';
import JourneyApiModel from './journey.api-model';
import LineApiModel from './line.api-model';
import StopPointApiModel from './stop-point.api-model';
import type { ITrafficSituation } from '../../../models/traffic-situation.model';
import { TrafficSituationHelper } from '../../../helpers/traffic-situation.helper';
import ActiveTimeApiModel from './active-time.api-model';

export default class TrafficSituationApiModel {
  public static mapToBusinessModel(apiModel: TrafficSituationApiModel): ITrafficSituation {
    return {
      situationNumber: apiModel.situationNumber,
      creationTime: DateTime.fromISO(apiModel.creationTime),
      startTime: DateTime.fromISO(apiModel.startTime),
      endTime: apiModel.endTime ? DateTime.fromISO(apiModel.endTime) : undefined,
      severity: TrafficSituationHelper.getTrafficSituationSeverityEnum(apiModel.severity),
      title: apiModel.title,
      description: apiModel.description,
      affectedStopPoints: apiModel.affectedStopPoints ? apiModel.affectedStopPoints.map(StopPointApiModel.mapToBusinessModel) : [],
      affectedLines: apiModel.affectedLines ? apiModel.affectedLines.map(LineApiModel.mapToBusinessModel) : [],
      affectedJourneys: apiModel.affectedJourneys ? apiModel.affectedJourneys.map(JourneyApiModel.mapToBusinessModel) : [],
      activeTimes: apiModel.activeTimes ? apiModel.activeTimes.map(ActiveTimeApiModel.mapToBusinessModel) : [],
      relativeDetailsUrl: apiModel.relativeDetailsUrl,
    };
  }

  situationNumber!: string;
  creationTime!: string;
  startTime!: string;
  endTime!: string;
  severity!: string;
  title!: string;
  description!: string;
  affectedStopPoints: StopPointApiModel[] | undefined;
  affectedLines: LineApiModel[] | undefined;
  affectedJourneys: JourneyApiModel[] | undefined;
  activeTimes: ActiveTimeApiModel[] | undefined;
  relativeDetailsUrl!: string;
}
